import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

var ConnectOneBotToShopInfoErrors;

(function (ConnectOneBotToShopInfoErrors) {
  ConnectOneBotToShopInfoErrors[ConnectOneBotToShopInfoErrors["inexistingShopInfo"] = 0] = "inexistingShopInfo";
  ConnectOneBotToShopInfoErrors[ConnectOneBotToShopInfoErrors["scriptTagShopifyNotInserted"] = 1] = "scriptTagShopifyNotInserted";
})(ConnectOneBotToShopInfoErrors || (ConnectOneBotToShopInfoErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ConnectOneBotToShopInfoErrors () { return ConnectOneBotToShopInfoErrors; }
});

const connectOneBotToShopInfo$2 = authenticatedRequest => async (shopInfosId, botId) => {
  try {
    const result = await authenticatedRequest('post', `/v1/bots/${botId}/connectors-config/shopify`, {
      shopInfosId
    });
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      if (error.response.data.error === 'inexistingShopInfo') {
        return ConnectOneBotToShopInfoErrors.inexistingShopInfo;
      }

      if (error.response.data.error === 'scriptTagShopifyNotInserted') {
        return ConnectOneBotToShopInfoErrors.scriptTagShopifyNotInserted;
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestShopInfosToShopInfos$1 = restShopInfos => ({
  accessToken: restShopInfos.accessToken,
  botId: restShopInfos.botId,
  clientId: restShopInfos.clientId,
  email: restShopInfos.email,
  id: restShopInfos.id,
  phoneNumber: restShopInfos.phoneNumber,
  scriptShopifyId: restShopInfos.scriptShopifyId,
  shopName: restShopInfos.shopName,
  shopOwner: restShopInfos.shopOwner,
  webhookId: restShopInfos.webhookId,
  websiteUrl: restShopInfos.websiteUrl
});

const connectOneBotToShopInfo$1 = authenticatedRequest => async (shopInfosId, botId) => {
  const result = await connectOneBotToShopInfo$2(authenticatedRequest)(shopInfosId, botId);

  if (genericUtils.isDomainError(result, ConnectOneBotToShopInfoErrors)) {
    return result;
  }

  return convertRestShopInfosToShopInfos$1(result);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  connectOneBotToShopInfo: connectOneBotToShopInfo$1
});

const saveOnePgActionConfig = pool => async pgInstalledActionConfig => {
  try {
    await pool.query(`INSERT INTO actions_installed_config(
          action_installed_id,
          config_key,
          config_value
        )
        VALUES (
          (SELECT actions_installed.id FROM actions_installed
          WHERE actions_installed.action_installed_id = $1),
          $2,
          $3
        )
        ON CONFLICT ON CONSTRAINT actioninstalledid_configkey
        DO UPDATE SET config_value=$3;`, [pgInstalledActionConfig.action_installed_id, pgInstalledActionConfig.config_key, pgInstalledActionConfig.config_value]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertOneInstalledActionConfigToManyPgInstalledActionConfig = installedActionConfig => {
  return installedActionConfig.config.map(configItem => ({
    action_installed_id: installedActionConfig.installedActionId,
    config_key: configItem.key,
    config_value: configItem.value
  }));
};

const saveOneShopifyInstalledActionConfig = pool => async installedActionConfig => {
  const pgInstalledActionConfigs = convertOneInstalledActionConfigToManyPgInstalledActionConfig(installedActionConfig);
  await Promise.all(pgInstalledActionConfigs.map(async pgInstalledActionConfig => {
    return saveOnePgActionConfig(pool)(pgInstalledActionConfig);
  }));
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  saveOneShopifyInstalledActionConfig: saveOneShopifyInstalledActionConfig
});

const saveOnePgInstalledAction = pool => async installedAction => {
  try {
    await pool.query(`INSERT INTO actions_installed(
          action_id,
          bot_id,
          action_installed_id
        )
        VALUES (
          (SELECT id
          FROM actions
          WHERE actions.action_id = $1
          ),
          $2,
          $3
        )
        ON CONFLICT ON CONSTRAINT botid_actionid DO UPDATE SET action_installed_id=$3;`, [installedAction.actionId, installedAction.botId, installedAction.id]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOnePgInstalledActionByBotId = pool => async botId => {
  try {
    await pool.query(`DELETE FROM "actions_installed"
          WHERE bot_id = $1;
             `, [botId]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOnePgConfigInstalledActionByBotId = pool => async botId => {
  try {
    await pool.query(`DELETE FROM "actions_installed_config"
         WHERE action_installed_id = (SELECT id
            FROM actions_installed
            WHERE bot_id = $1) ;
             `, [botId]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOneInstalledAction = pool => async installedAction => {
  await saveOnePgInstalledAction(pool)(installedAction);
};

const removeOneShopifyActionByBotId = pool => async botId => {
  await deleteOnePgConfigInstalledActionByBotId(pool)(botId);
  await deleteOnePgInstalledActionByBotId(pool)(botId);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  removeOneShopifyActionByBotId: removeOneShopifyActionByBotId,
  saveOneInstalledAction: saveOneInstalledAction
});

const getOnePgActionById = pool => async id => {
  var _a;

  try {
    const result = await pool.query(`SELECT
          actions.action_id,
          actions.name
        FROM actions
        WHERE actions.action_id = $1`, [id]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOnePgAction = pool => async action => {
  try {
    await pool.query(`INSERT INTO actions(
          action_id,
          name
        )
        VALUES (
          $1,
          $2
        );`, [action.id, action.name]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertOnePgActionToAction = pgAction => ({
  id: pgAction.action_id,
  name: pgAction.name
});

const getOneActionById = pool => async actionId => {
  const pgAction = await getOnePgActionById(pool)(actionId);

  if (pgAction === null) {
    return null;
  }

  return convertOnePgActionToAction(pgAction);
};

const saveOneAction = pool => async action => {
  await saveOnePgAction(pool)(action);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneActionById: getOneActionById,
  saveOneAction: saveOneAction
});

const getOneRestShopInfosById = axios => async shopInfoId => {
  try {
    const restShopInfos = await axios.get(`/v1/shopify-shop-infos/${shopInfoId}`);
    return restShopInfos.data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const sendScriptShopifyAxios = axios => async (webchatId, shopId, accessToken) => {
  try {
    const scriptShopify = await axios.post(`https://${shopId}.myshopify.com/admin/api/2021-10/metafields.json`, {
      metafield: {
        key: 'webchatId',
        namespace: 'webchat',
        type: 'string',
        value: webchatId
      }
    }, {
      headers: {
        'X-Shopify-Access-Token': accessToken
      }
    });
    return scriptShopify.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const removeScriptShopifyAxios = axios => async (scriptShopifyId, shopId, accessToken) => {
  await axios.delete(`https://${shopId}.myshopify.com/admin/api/2021-10/metafields/${scriptShopifyId}.json`, {
    headers: {
      'X-Shopify-Access-Token': accessToken
    }
  });
};

const updateOneShopInfo$1 = axios => async shopInfos => {
  try {
    await axios.put(`/v1/shopify-shop-infos/${shopInfos.id}`, shopInfos);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneRestShopInfosByBotId = axios => async botId => {
  try {
    const restShopInfos = await axios.get(`/v1/bots/${botId}/shop-infos`);
    return restShopInfos.data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneMongoBotByBotId = mongodb => async botId => {
  var _a;

  try {
    const mongoBots = await mongodb.collection('api_bots').aggregate([{
      $match: {
        bot_id: botId
      }
    }, {
      $lookup: {
        as: 'webchat',
        foreignField: 'bot_id',
        from: 'api_webchat',
        localField: 'bot_id'
      }
    }, {
      $project: {
        _id: 0,
        bot_id: 1,
        modified: 1,
        name: 1,
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        webchat_id: {
          $arrayElemAt: ['$webchat.webchat_id', 0]
        }
      }
    }]).toArray();
    return (_a = mongoBots[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestShopInfosToShopInfos = restShopInfos => ({
  accessToken: restShopInfos.accessToken,
  botId: restShopInfos.botId,
  clientId: restShopInfos.clientId,
  email: restShopInfos.email,
  id: restShopInfos.id,
  phoneNumber: restShopInfos.phoneNumber,
  scriptShopifyId: restShopInfos.scriptShopifyId,
  shopName: restShopInfos.shopName,
  shopOwner: restShopInfos.shopOwner,
  webhookId: restShopInfos.webhookId,
  websiteUrl: restShopInfos.websiteUrl
});

const convertMetaFieldsScriptShopifyToScriptShopify = metaFieldsScriptShopify => ({
  id: metaFieldsScriptShopify.id.toString()
});

const convertMongoBotToWebchatId = persistedMongoBot => persistedMongoBot.webchat_id;

const getOneShopInfosById = axios => async shopInfosId => {
  const restShopInfos = await getOneRestShopInfosById(axios)(shopInfosId);
  return restShopInfos === null ? null : convertRestShopInfosToShopInfos(restShopInfos);
};

const insertOneWebchatScriptOnShopify = (mongodb, axios) => async (botId, shopId, accessToken) => {
  const mongoBot = await getOneMongoBotByBotId(mongodb)(botId);

  if (mongoBot === null) {
    return null;
  }

  const restScriptShopify = await sendScriptShopifyAxios(axios)(convertMongoBotToWebchatId(mongoBot), shopId, accessToken);
  return convertMetaFieldsScriptShopifyToScriptShopify(restScriptShopify.metafield);
};

const updateOneShopInfo = axios => async shopInfos => {
  await updateOneShopInfo$1(axios)(shopInfos);
};

const removeOneWebchatScriptOnShop = axios => async shopInfos => {
  if (shopInfos.scriptShopifyId !== null) {
    await removeScriptShopifyAxios(axios)(shopInfos.scriptShopifyId, shopInfos.id, shopInfos.accessToken);
  }
};

const getOneShopInfosByBotId = axios => async botId => {
  const restShopInfos = await getOneRestShopInfosByBotId(axios)(botId);
  return restShopInfos === null ? null : convertRestShopInfosToShopInfos(restShopInfos);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneShopInfosByBotId: getOneShopInfosByBotId,
  getOneShopInfosById: getOneShopInfosById,
  insertOneWebchatScriptOnShopify: insertOneWebchatScriptOnShopify,
  removeOneWebchatScriptOnShop: removeOneWebchatScriptOnShop,
  updateOneShopInfo: updateOneShopInfo
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestShopInfos: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestShopInfosId"
			},
			accessToken: {
				$ref: "#/definitions/RestShopInfosAccessToken"
			},
			email: {
				$ref: "#/definitions/RestShopInfosEmail"
			},
			websiteUrl: {
				$ref: "#/definitions/RestShopInfosUrl"
			},
			scriptShopifyId: {
				$ref: "#/definitions/RestShopInfosScriptShopifyId"
			},
			shopName: {
				$ref: "#/definitions/RestShopInfosShopName"
			},
			shopOwner: {
				$ref: "#/definitions/RestShopInfosShopOwner"
			},
			botId: {
				$ref: "#/definitions/RestShopInfosBotId"
			},
			clientId: {
				$ref: "#/definitions/RestShopInfosClientId"
			},
			webhookId: {
				$ref: "#/definitions/RestShopInfosWebhhokId"
			},
			phoneNumber: {
				$ref: "#/definitions/RestShopInfosPhoneNumber"
			}
		},
		required: [
			"id",
			"accessToken",
			"email",
			"websiteUrl",
			"scriptShopifyId",
			"shopName",
			"shopOwner",
			"botId",
			"clientId",
			"webhookId",
			"phoneNumber"
		],
		additionalProperties: false
	},
	RestShopInfosId: {
		type: "string"
	},
	RestShopInfosAccessToken: {
		type: "string"
	},
	RestShopInfosEmail: {
		type: "string"
	},
	RestShopInfosUrl: {
		type: "string"
	},
	RestShopInfosScriptShopifyId: {
		type: [
			"string",
			"null"
		]
	},
	RestShopInfosShopName: {
		type: "string"
	},
	RestShopInfosShopOwner: {
		type: "string"
	},
	RestShopInfosBotId: {
		type: [
			"string",
			"null"
		]
	},
	RestShopInfosClientId: {
		type: [
			"string",
			"null"
		]
	},
	RestShopInfosWebhhokId: {
		type: [
			"string",
			"null"
		]
	},
	RestShopInfosPhoneNumber: {
		type: [
			"string",
			"null"
		]
	},
	ActionId: {
		type: "string"
	},
	Action: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ActionId"
			},
			name: {
				type: "string"
			}
		},
		required: [
			"id",
			"name"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	InstalledActionId: {
		type: "string"
	},
	ConfigItem: {
		type: "object",
		properties: {
			key: {
				type: "string"
			},
			value: {
				type: "string"
			}
		},
		required: [
			"key",
			"value"
		],
		additionalProperties: false
	},
	InstalledActionConfig: {
		type: "object",
		properties: {
			installedActionId: {
				$ref: "#/definitions/InstalledActionId"
			},
			config: {
				type: "array",
				items: {
					$ref: "#/definitions/ConfigItem"
				}
			}
		},
		required: [
			"installedActionId",
			"config"
		],
		additionalProperties: false
	},
	InstalledAction: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/InstalledActionId"
			},
			actionId: {
				$ref: "#/definitions/ActionId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id",
			"actionId",
			"botId"
		],
		additionalProperties: false
	},
	ShopInfosId: {
		type: "string"
	},
	ShopInfosUrl: {
		type: "string"
	},
	ShopInfosAccessToken: {
		type: "string"
	},
	ShopInfosShopName: {
		type: "string"
	},
	ShopInfosShopOwner: {
		type: "string"
	},
	ShopInfosEmail: {
		type: "string"
	},
	WebchatId: {
		type: "string"
	},
	ScriptShopifyId: {
		type: "string"
	},
	ShopInfos: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ShopInfosId"
			},
			accessToken: {
				$ref: "#/definitions/ShopInfosAccessToken"
			},
			email: {
				$ref: "#/definitions/ShopInfosEmail"
			},
			websiteUrl: {
				$ref: "#/definitions/ShopInfosUrl"
			},
			shopName: {
				$ref: "#/definitions/ShopInfosShopName"
			},
			shopOwner: {
				$ref: "#/definitions/ShopInfosShopOwner"
			},
			botId: {
				type: [
					"string",
					"null"
				]
			},
			clientId: {
				type: [
					"string",
					"null"
				]
			},
			scriptShopifyId: {
				anyOf: [
					{
						$ref: "#/definitions/ScriptShopifyId"
					},
					{
						type: "null"
					}
				]
			},
			webhookId: {
				type: [
					"string",
					"null"
				]
			},
			phoneNumber: {
				type: [
					"string",
					"null"
				]
			}
		},
		required: [
			"id",
			"accessToken",
			"email",
			"websiteUrl",
			"shopName",
			"shopOwner",
			"botId",
			"clientId",
			"scriptShopifyId",
			"webhookId",
			"phoneNumber"
		],
		additionalProperties: false
	},
	ScriptShopify: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ScriptShopifyId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	PgInstalledActionConfig: {
		type: "object",
		properties: {
			action_installed_id: {
				type: "string"
			},
			config_key: {
				type: "string"
			},
			config_value: {
				type: "string"
			}
		},
		required: [
			"action_installed_id",
			"config_key",
			"config_value"
		],
		additionalProperties: false
	},
	PgInstalledAction: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			action_id: {
				type: "string"
			},
			action_installed_id: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"action_id",
			"action_installed_id"
		],
		additionalProperties: false
	},
	PgAction: {
		type: "object",
		properties: {
			action_id: {
				type: "string"
			},
			name: {
				type: "string"
			}
		},
		required: [
			"action_id",
			"name"
		],
		additionalProperties: false
	},
	MetaFieldsScriptShopify: {
		type: "object",
		properties: {
			owner_id: {
				type: "string"
			},
			id: {
				type: "number"
			}
		},
		required: [
			"owner_id",
			"id"
		],
		additionalProperties: false
	},
	RestScriptShopify: {
		type: "object",
		properties: {
			metafield: {
				$ref: "#/definitions/MetaFieldsScriptShopify"
			}
		},
		required: [
			"metafield"
		],
		additionalProperties: false
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			modified: {
				type: "boolean"
			},
			webchat_id: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"name",
			"modified",
			"webchat_id"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const installedActionFactory = () => (actionId, botId, id) => ({
  actionId,
  botId,
  id: id !== null && id !== void 0 ? id : genericUtils.generateUniqueId()
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  installedActionFactory: installedActionFactory
});

const connectOneBotToShopInfo = (actionId, getOneShopInfosById, getOneActionById, saveOneAction, installedActionFactory, saveOneInstalledAction, saveOneShopifyInstalledActionConfig, insertOneWebchatScriptOnShopify, updateOneShopInfos) => async (shopInfosId, botId) => {
  const shopInfos = await getOneShopInfosById(shopInfosId);

  if (shopInfos === null) {
    return ConnectOneBotToShopInfoErrors.inexistingShopInfo;
  }

  const scriptShopify = await insertOneWebchatScriptOnShopify(botId, shopInfos.id, shopInfos.accessToken);

  if (scriptShopify === null) {
    return ConnectOneBotToShopInfoErrors.scriptTagShopifyNotInserted;
  }

  const existingShopifyAction = await getOneActionById(actionId);

  if (existingShopifyAction === null) {
    await saveOneAction({
      id: actionId,
      name: 'shopify'
    });

    const _installedAction = installedActionFactory(actionId, botId);

    await saveOneInstalledAction(_installedAction);
  }

  const installedAction = installedActionFactory(actionId, botId);
  await saveOneInstalledAction(installedAction);
  const installedActionConfig = {
    config: [{
      key: 'SHOPIFY_1_0_AccessToken',
      value: shopInfos.accessToken
    }, {
      key: 'SHOPIFY_1_0_baseUrl',
      value: shopInfos.websiteUrl
    }],
    installedActionId: installedAction.id
  };
  await saveOneShopifyInstalledActionConfig(installedActionConfig);
  const updatedShopInfos = Object.assign(Object.assign({}, shopInfos), {
    botId,
    scriptShopifyId: scriptShopify.id.toString()
  });
  await updateOneShopInfos(updatedShopInfos);
  return updatedShopInfos;
};

export { applicationPorts as appPorts, index$5 as axiosConnectorConfigShopify, connectOneBotToShopInfo, entitiesSchemas$1 as entitiesSchemas, index as installedActionModel, index$1 as mongodbAxiosShopInfosRepository, index$4 as postgresqlActionsInstalledConfigRepository, index$3 as postgresqlActionsInstalledRepository, index$2 as postgresqlActionsRepository };
